import { Injectable } from "@angular/core";

import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { filter, first, map } from "rxjs/operators";

import { ForbrugsnotifikationOpsaetning, ForbrugsnotifikationType } from "../model/forbrugsnotifikation-opsaetning.model";
import { ForbrugsnotifikationOpsaetningViewModel } from "../model/forbrugsnotifikation-opsaetning.view-model";
import { ForbrugsnotifikationFormBuilder } from "./forbrugsnotifikation.form-builder";
import { ForbrugsnotifikationRepository } from "./forbrugsnotifikation.repository";

@Injectable({ providedIn: "root" })
export class ForbrugsnotifikationService {
    private vm = new BehaviorSubject<ForbrugsnotifikationOpsaetningViewModel>(null);
    constructor(
        private readonly repository: ForbrugsnotifikationRepository,
        private readonly formBuilder: ForbrugsnotifikationFormBuilder
    ) {}

    public hent(): Observable<ForbrugsnotifikationOpsaetningViewModel> {
        const result = combineLatest([this.repository.hentIndstillinger(), this.repository.hentForbrugsnotifikationOpsaetning()])
            .pipe(
                map(([indstillinger, opsaetning]) => ({
                    indstillinger,
                    formGroup: this.formBuilder.opsaetningToFormGroup(opsaetning, indstillinger),
                    erTilmeldt: this.beregnErTilmeldt(opsaetning)
                })),
                first()
            )
            .toPromise();
        result.then((r) => this.vm.next(r));
        return this.vm.pipe(filter((data) => !!data));
    }

    public async gem(vm: ForbrugsnotifikationOpsaetningViewModel): Promise<void> {
        const opsaetning = this.formBuilder.formGroupToOpsaetning(vm.formGroup);
        await this.repository.gemForbrugsnotifikationOpsaetning(opsaetning);
        const formGroup = this.formBuilder.opsaetningToFormGroup(opsaetning, vm.indstillinger);
        const erTilmeldt = this.beregnErTilmeldt(opsaetning);
        this.vm.next({ erTilmeldt, formGroup, indstillinger: vm.indstillinger });
    }

    private beregnErTilmeldt(opsaetning: ForbrugsnotifikationOpsaetning): boolean {
        return opsaetning.udsendelse.type === ForbrugsnotifikationType.mail || opsaetning.udsendelse.type === ForbrugsnotifikationType.sms;
    }
}
